import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static outlets = ['selectable-table-actions']
  static targets = ['row', 'rowSelector']

  changeAll(selected) {
    for (let i = 0; i < this.rowSelectorTargets.length; i++) {
      this.rowSelectorTargets[i].checked = selected
    }
    this.selectionChanged()
  }

  selectionChanged() {
    this.updateRowSelectedClass()
    this.selectableTableActionsOutlet.selectionChanged()
  }

  // CSS and other JS (i.e. in app/views/users/index.html.erb) use classes as
  // the source of truth on if a row is selected. So we sync that classes to
  // status of the rowSelector checkboxes.
  updateRowSelectedClass() {
    for (let i = 0; i < this.rowSelectorTargets.length; i++) {
      this.rowTargets[i].classList
        .toggle('selected', this.rowSelectorTargets[i].checked)
    }
  }

  hasSelectedRows() {
    return this.rowSelectorTargets.some(selector => selector.checked)
  }

  hasUnselectedRows() {
    return this.rowSelectorTargets.some(selector => !selector.checked)
  }
}
